import { __assign } from "tslib";
import memoize from 'fast-memoize';
import { formatCurrency, formatCurrencyToParts } from './formatCurrency';
import { formatDate } from './formatDate';
import { formatMessage, formatMessageToParts } from './formatMessage';
import { formatNumber } from './formatNumber';
import { getDateTimeFormatter, getMessageFormatter, getNumeralFormatter } from './formatters';
import { createFastMemoizeCache, createIntlCache, getPreferences, formatEmployeeName, formatEmployeeNameSalutation, } from './utils';
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    return {
        getNumeralFormatter: memoize(getNumeralFormatter, {
            cache: createFastMemoizeCache(cache.number),
            strategy: memoize.strategies.variadic,
        }),
        getDateTimeFormatter: memoize(getDateTimeFormatter, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: memoize.strategies.variadic,
        }),
        getMessageFormatter: getMessageFormatter,
    };
}
/**
 * Creates intl formatter functions
 */
export function createIntl(_pref, cache, customFormatters) {
    var preferences = getPreferences(_pref);
    var formatters = __assign(__assign({}, createFormatters(cache)), { preferences: preferences });
    var locale = preferences.locale, timeFormat = preferences.timeFormat, dateFormat = preferences.dateFormat, numberFormat = preferences.numberFormat;
    return __assign({ preferences: preferences, moment: formatters.getDateTimeFormatter(locale, dateFormat, timeFormat), numeral: formatters.getNumeralFormatter(locale, numberFormat), formatDate: formatDate.bind(null, formatters), formatNumber: formatNumber.bind(null, formatters), formatCurrency: formatCurrency.bind(null, formatters), formatCurrencyToParts: formatCurrencyToParts.bind(null, formatters), formatMessage: formatMessage.bind(null, formatters), formatMessageToParts: formatMessageToParts.bind(null, formatters), formatEmployeeName: formatEmployeeName.bind(null, formatters), formatEmployeeNameSalutation: formatEmployeeNameSalutation.bind(null, formatters), translate: formatMessage.bind(null, formatters), 
        // Export these to remain consistent with nui-intl
        /**
         * @deprecated use formatDate function instead. Will be removed in the next major version
         */
        formattedDate: formatDate.bind(null, formatters), 
        /**
         * @deprecated use formatNumber function instead. Will be removed in the next major version
         */
        formattedNumber: formatNumber.bind(null, formatters), 
        /**
         * @deprecated use formatCurrency function instead. Will be removed in the next major version
         */
        formattedCurrency: formatCurrency.bind(null, formatters), 
        /**
         * @deprecated use formatMessage function instead.Will be removed in the next major version
         */
        formattedMessage: formatMessage.bind(null, formatters) }, customFormatters);
}
